export default "/fonts/Museo300-Regular-webfont.woff2?89375bfc4c62c7a605bca4c50b5cf511";